import React, { useMemo } from 'react';
import { FaDownload, FaExternalLinkAlt, FaQrcode } from 'react-icons/fa';
import Modal from './Modal';

export default function QrCodeModal({ open, onClose, link, formName, onCopyLink = null }) {
  const qrCodeUrl = useMemo(() => {
    if (!link) return '';
    return `https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=${encodeURIComponent(link)}`;
  }, [link]);

  return (
    <Modal open={open} onClose={onClose} size="max-w-xl">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-100 text-blue-700">
          <FaQrcode />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">QR Code do formulário</h2>
          <p className="text-sm text-slate-600">Gere um QR Code para compartilhar rapidamente o acesso externo.</p>
        </div>
      </div>

      {qrCodeUrl ? (
        <div className="space-y-4">
          <div className="rounded-2xl border border-slate-200 bg-slate-50/70 p-4 text-center">
            <div className="mx-auto inline-flex items-center justify-center rounded-xl bg-white p-4 shadow-inner">
              <img
                src={qrCodeUrl}
                alt={`QR Code para ${formName || 'formulário'}`}
                className="h-60 w-60"
              />
            </div>
            {formName ? (
              <p className="mt-3 text-sm font-medium text-slate-700">{formName}</p>
            ) : null}
            <p className="mt-1 text-xs text-slate-500">Escaneie para abrir o formulário externo.</p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <a
              href={qrCodeUrl}
              download={`${formName || 'formulario'}-qrcode.png`}
              className="inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 transition hover:border-blue-300 hover:bg-blue-100"
            >
              <FaDownload />
              Baixar QR Code
            </a>
            {onCopyLink ? (
              <button
                type="button"
                onClick={onCopyLink}
                className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
              >
                <FaExternalLinkAlt />
                Copiar link externo
              </button>
            ) : null}
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-xl border border-green-200 bg-green-50 px-4 py-2 text-sm font-semibold text-green-700 transition hover:border-green-300 hover:bg-green-100"
            >
              <FaExternalLinkAlt />
              Abrir formulário
            </a>
          </div>
        </div>
      ) : (
        <p className="text-sm text-red-600">Link externo indisponível para gerar o QR Code.</p>
      )}
    </Modal>
  );
}
